

import { Button } from "@material-ui/core";
import useStyles from "./styles";

interface ConfirmModalInterface {
  handleOk: (e: any) => void, 
  handleClose: (e: any) => void, 
  title?: string, 
  subTitle?: string, 
  textBtnOk?: string
}

const ConfirmModal = (props: ConfirmModalInterface) => {
  const classes = useStyles();

  const onClose = (e: any) => {
    if (props?.handleClose ) props?.handleClose(e);
  };

  const onHandleOk = (e: any) => {
    if (props?.handleOk) props?.handleOk(e);
  };

  return (
    <div className={classes.container} onClick={onClose} data-cy='cypress-unlaunch-app-modal'>
      <div className={classes.title}>{props?.title}</div>
      <div className={classes.subtitle} data-cy='cypress-modal-subtitle'>{props?.subTitle}</div>
      <div className={classes.buttonContainer}>
        <Button className={classes.cancelBtn} onClick={onClose} data-cy='cypress-complete-setup-cancel-tap'>Cancel</Button>
        <Button className={classes.okBtn} onClick={onHandleOk} data-cy='cypress-complete-setup-got-it-tap'>Got It</Button>
      </div>
    </div>
  );
};

export default ConfirmModal;
